module.exports = __webpack_public_path__ + "static/media/jeris.08d4cc37.png";